export const style = {
  tabsContainer: {
    sx: {
      padding: '0px 24px',
      mt: '24px',
    },
  },
  containerMain: {
    sx: {
      pt: 8,
      pb: 8,
      pX: 0,
      mX: 0,
      display: 'flex',
    },
  },
  containerTalentEdit: {
    flex: 1,
    position: 'relative',
  },
  containerTalentEditInner: {
    margin: '0 auto',
    width: 960,
  },
} as const;
